import moment from 'moment';
import * as yup from 'yup';
const { yupResolver } = require('@hookform/resolvers/yup');

export const branchActivityFormDefaultValues = {
  id: '',
  formType: 'create',
  desctiption: '',
  startDate: moment(new Date()),
  endDate: moment(new Date()).add(7, 'days'),
  display: true,
};

export const branchActivityFormSchema = () => {
  return yupResolver(
    yup.object().shape({
      desctiption: yup.string().required('กรุณาใส่รายละเอียด'),
      startDate: yup.string().required('กรุณาเลือกวันที่เริ่มต้น'),
      endDate: yup.string().required('กรุณาเลือกวันที่สิ้นสุด'),
    })
  );
};
